import React, { useEffect , useState } from 'react';
import { useHistory , useParams } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { FaEye , FaEyeSlash } from "react-icons/fa";

import { useGlobalContext } from '../../../context/GlobalContext';
import { resetPasswordAction } from '../../../actions/authActions';

import './auth.scss';

export default function ResetPasswordPage() {

  const history = useHistory();
  const params = useParams();

  const { handleSubmit, register, errors } = useForm();
  
  const [ context, dispatch ] = useGlobalContext();

  const [ errorReset , setErrorReset] = useState();
  const [ errorPassword , setErrorPassword ] = useState();
  const [ message , setMessage ] = useState();
  const [ showPassword , setShowPassword ] = useState(false);

  useEffect(() => {
    if (context.auth.message && context.auth.message.reset) {
      setMessage("Le mot de passe a été modifié avec succès. Veuillez vous connecter avec votre nouveau mot de passe.")
    }
    if (context.auth.error && context.auth.error.data && context.auth.error.data.error === "Your token has expired. Please attempt to reset your password again.") {
      setErrorReset("Votre jeton a expiré. Veuillez réessayer de réinitialiser votre mot de passe.")
    }
    if (context.auth.error && context.auth.error.data && context.auth.error.data.error === "You must enter a password strong enough.") {
      setErrorPassword("Vous devez entrer un mot de passe suffisamment fort.")
    }
  }, [context.auth.message , context.auth.error])

  const submitPassword = (values)  => {
    values.token = params.token
    resetPasswordAction( dispatch , values);
    dispatch({
      type: 'ERROR_AUTH',
      payload: null,
    });
  };

  function renderConfirmPassword() {
    return (
      <form className="form-login" onSubmit={handleSubmit(submitPassword)}>
        
        {!errorReset && !message &&
          <>
            <label htmlFor="password">Mot de passe</label>
            <input
              name="password"
              className="primary"
              type={showPassword? "text" : "password"}
              ref={register({
                required: "Compléter votre mot de passe",
              })}
            />

            <div
              className="eye-reset"
              onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEye size={20} color={"#4744BA"} /> : <FaEyeSlash size={20} color={"#4744BA"} /> }
            </div>

            {errors.password  && errors.password.message && <p className="text-center text-error">{errors.password.message}</p>}
            {errorPassword && <p className="text-center text-error">{errorPassword}</p> }

            <div className="btn-container">
              <button className="btn primary" type="submit">Valider le nouveau mot de passe</button>
            </div>
          </>
        }

        {errorReset && 
          <>
            <p className="text-center m-md">{errorReset}</p>
            <div className="btn-container">
              <button className="btn primary" onClick={() => history.push("/login")}>Retour à la page de connexion</button>
            </div>
          </>
        }

        {message && 
          <div className="form-reset message">
            <p className="text-center">{message}</p>
            <button className="btn primary" onClick={() => history.push("/login")}>Retour à la page de connexion</button>
          </div>
        }
    
      </form>
    )
  }

  return (
    <div className="login">
      <div className="col-img"></div>
      <div className="col-form">
        <p className="title bold">
          <span className="name">Généaloviz</span><br/>
          <span className="regular">BY </span><span>octapharma</span>
        </p>
        {renderConfirmPassword()}
      </div>
    </div>
  );
};